<template>
    <el-dialog title="批量打包" :visible.sync="open" :center="true" width="50%" @close="cancel"
        :close-on-click-modal="false" :destroy-on-close="true" :show-close="false">
        <el-table :data="packagedData" border style="width: auto; margin: 10px 0px" height="300"
            :header-cell-style="{ background: '#e4e4e4' }">
            <el-table-column type="index" width="50" label="序号"> </el-table-column>
            <el-table-column prop="productName" label="产品" min-width="180"></el-table-column>
            <el-table-column prop="specName" label="规格型号" width="180"></el-table-column>
            <el-table-column prop="manufacturerName" label="生产厂家" width="150"></el-table-column>
            <el-table-column prop="quantitySum" label="可打包数量" width="140"></el-table-column>
            <el-table-column label="每包数量" width="180">
                <template slot-scope="scope">
                    <el-input-number size="small" v-model="scope.row.quantityPerPackage"
                        @change="(res) => numberEvt(res, scope.row)" :min="1" :max="scope.row.quantitySum"
                        label="请输入内容"></el-input-number>
                </template>
            </el-table-column>
        </el-table>
        <div>
            <span>打包包数:&nbsp; &nbsp; </span>
            <el-input-number size="small" v-model="packNum" :min="1" :max="maxPackNum" label="请输入内容"></el-input-number>
        </div>
        <div slot="footer" class="footer-bottom">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button type="primary" size="small" @click="confirm">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: "batchPackDialog",
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        packagedData: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            packNum: "",
            maxPackNum: 0,
            //   open: false,
            //   packagedData:[   ]
        };
    },
    watch:{
        open(n,o){
            if(n){
                this.setPackNum()
            }
            
        }
    },
  
    methods: {
        cancel() {
            this.packNum  = 0
            this.$emit("cancel", false);
        },
        confirm() {
            // 过滤掉 quantityPerPackage 为0的项
            const validData = this.packagedData.filter(item => item.quantityPerPackage > 0);
            validData.forEach((item) => {
                item.packNum = this.packNum;
            });
            this.$emit("confirm", validData); // 传递过滤后的有效数据
        },
        setPackNum(){
            if (this.packagedData.length == 1) {
                this.packNum = this.packagedData[0].quantitySum;
                this.maxPackNum = this.packagedData[0].quantitySum;
                return;
            }
            // 初始化最小值为无穷大，最小项为null
            let minQuantitySum = Infinity;
            let minItem = null;
            this.packagedData.forEach((item) => {
                // 将quantitySum转换为数值（兼容字符串类型）
                const currentQuantitySum = item.quantitySum - 0;
                // 过滤无效值（如非数字、负数等，根据业务需求调整）
                if (typeof currentQuantitySum === 'number' && !isNaN(currentQuantitySum)) {
                    // 比较并更新最小值和对应项
                    if (currentQuantitySum < minQuantitySum) {
                        minQuantitySum = currentQuantitySum;
                        minItem = item;
                    }
                }
            });
            // 处理找到最小项的情况
            if (minItem) {
                // 根据业务需求使用最小项（示例：设置packNum为最小quantitySum）
                this.packNum = minItem.quantitySum;
                this.maxPackNum = minItem.quantitySum;
            } 
        },
       
        numberEvt(res, row) {
            // 新增：校验res是否为整数，非整数则转换为整数（示例使用向下取整）
            if (typeof res !== 'number' || !Number.isInteger(res)) {
                res = Math.floor(res); // 或根据需求使用Math.ceil等
                this.$set(row, 'quantityPerPackage', res);
            }
            let minPackNum = Infinity; // 重置最小打包数
            let minItem = null; // 记录最小的那条数据
            this.packagedData.forEach((item) => {
                
                // 避免除以0和无效输入
                if (item.quantitySum > 0 && item.quantityPerPackage > 0) {
                    const current = Math.floor(item.quantitySum / item.quantityPerPackage);
                    if (current < minPackNum) {
                        minPackNum = current;
                        minItem = item; // 更新最小数据项
                    }
                }
            });
            // 处理无有效数据的情况（所有项都不满足条件）
            this.packNum = minPackNum;
            this.maxPackNum = minPackNum;
        },
     
     
    },
};
</script>
